import { render, staticRenderFns } from "./ManageStudentReqPIIs.vue?vue&type=template&id=1b83152b&"
import script from "./ManageStudentReqPIIs.vue?vue&type=script&lang=js&"
export * from "./ManageStudentReqPIIs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports